import { MessageCircle, Mail } from "lucide-react";

export const WHATSAPP_NUMBER = "447784682148"; // +44 7784 682148
export const CONTACT_EMAIL = "uktranspet@gmail.com";

export function whatsappHref(message = "Hi! I'd like to ask about pet transport.") {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function emailHref(subject = "Pet transport enquiry", body = "") {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  return `mailto:${CONTACT_EMAIL}?${params.toString()}`;
}

export default function ContactFloating() {
  return (
    <div className="fixed z-50 bottom-6 right-6 flex flex-col gap-3 items-end" data-testid="contact-floating">
      <a
        href={whatsappHref()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-float-btn"
        className="inline-flex items-center gap-2 h-14 pl-4 pr-5 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1ebe57] hover:scale-105 transition-all duration-200 font-medium text-sm"
      >
        <MessageCircle size={20} strokeWidth={2} fill="white" stroke="#25D366" />
        <span className="hidden sm:inline">Chat on WhatsApp</span>
      </a>
      <a
        href={emailHref()}
        aria-label="Email us"
        data-testid="email-float-btn"
        className="inline-flex items-center gap-2 h-14 pl-4 pr-5 rounded-full bg-foreground text-background shadow-lg hover:bg-primary hover:scale-105 transition-all duration-200 font-medium text-sm"
      >
        <Mail size={18} strokeWidth={2} />
        <span className="hidden sm:inline">Email us</span>
      </a>
    </div>
  );
}
